@if (lesson) {
  <div class="lesson-display">
    <!-- Lesson Header -->
    <div class="lesson-header">
      <h1 class="lesson-title">{{ lesson.title }}</h1>
      @if (hasDescription) {
        <p class="lesson-description">
          {{ lesson.description }}
        </p>
      }
    </div>
    <!-- Lesson Content Sections -->
    @if (hasSections) {
      <div class="lesson-content">
        @for (section of lesson.sections; track section; let i = $index) {
          <div
            class="lesson-section">
            <!-- Section Title (skip for first section per requirements) -->
            @if (i > 0 && section.title) {
              <h2
                class="section-title">
                {{ section.title }}
              </h2>
            }
            <!-- Section Content (HTML with Markdown support) -->
            <article
              class="section-content"
              [innerHTML]="getSafeHtml(section.content)"
              (click)="onContentClick($event)">
            </article>
          </div>
        }
      </div>
    }
    <!-- Empty State -->
    @if (!hasSections) {
      <div class="lesson-empty">
        <p>This lesson has no content yet.</p>
      </div>
    }
  </div>
}

<ut-image-lightbox />

<!-- Loading/Empty State -->
@if (!lesson) {
  <div class="lesson-display-empty">
    <p>No lesson selected</p>
  </div>
}
